import { useMutation } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'

interface CreateMergeLinkTokenResponse {
  link_token: string;
}

export function useCreateMergeLinkToken () {
  return useMutation<
    CreateMergeLinkTokenResponse,
    GrapeAPIErrorType,
    { payrollProviderConfigId: string }
  >({
    mutationFn: async ({ payrollProviderConfigId }) => {
      const response = await fetchWithHeaders(
        '/api/web/payroll/merge/create_link_token',
        {
          method: 'POST',
          body: JSON.stringify({ payroll_provider_config_id: payrollProviderConfigId }),
        }
      )

      if (!response.ok) {
        const errors = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }

      return response.json()
    },
  })
}
